import { gql } from "@apollo/client";

// Only used to look up the node-subscription setting container id before
// creating the first subscription (ensureSettingContainer). Tolerated to
// fail — the backend auto-creates the container on demand.
export const NodeSubscriptionSettingContainer = gql`
    query NodeSubscriptionSettingContainer {
        notificationSettings {
            id
            installedBase {
                __typename
                id
            }
        }
    }
`;
